/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgBillingSummary16(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      fill='none'
      viewBox='0 0 16 16'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.45}
        d='M10 8.043h3.89c.293 0 .577-.104.785-.289A.936.936 0 0015 7.056v-.305a.936.936 0 00-.325-.698 1.186 1.186 0 00-.786-.29h-2.368c-.294 0-.578-.103-.786-.288a.936.936 0 01-.324-.698V4.5c0-.261.116-.512.324-.698.208-.185.492-.289.786-.289H15'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.4}
        d='M12.618 8.38v1.87M12.618 1.25v2.638'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M10.197 1H1.5v12.514c0 .394.153.772.424 1.05.272.28.64.436 1.024.436H12.5M4 4.5h4M4 7.318h1.94'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M3.429 15H3.5c.416 0 .745-.158 1.04-.439.293-.281.459-.662.459-1.06V12h9.5v1.501c0 .398-.165.779-.46 1.06a1.61 1.61 0 01-1.11.439h-.001'
      />
    </svg>
  );
}

export default SvgBillingSummary16;
